import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { getAxios } from "src/helpers/index";


/** Retrieve all monthly reports data -------------------------- **/
export const getAllReportsData = createAsyncThunk("reports/getAllReportsData", async (model, thunkAPi) => {
    try {
        let url = `/Report/${model.type}`
        if (model.type === "Daily") {
            url = `${url}?reportDate=${model?.startDate}`
        } else if (model.type === "Weekly") {
            let week = (model?.week || '').slice(4, 5)
            url = `${url}?week=${week}&month=${(model?.month)}&year=${model?.year}`
        } else if (model.type === "Monthly") {
            url = `${url}?month=${(model?.month)}&year=${model?.year}`

        } else if (model?.type === "Quarterly") {
            url = `${url}?quarter=${model?.quarter}&year=${model?.year}`
        } else if (model?.type === "Yearly") {
            url = `${url}?year=${model?.year}`
        }
        url = url + "&depotId=" + model?.depotId
        url = url + "&clientId=" + model?.clientId
        url = url + "&projectId=" + model?.projectId

        let result = await getAxios().get(`${url}`);
        let newResult = {
            ...result?.data,
            DataTable: _.orderBy(result?.data?.DataTable, ['clientName'], ['asc'])
        }
        return newResult
    } catch (error) {
        return thunkAPi.rejectWithValue(error);
    }
});
export const getAllItemInventoryData = createAsyncThunk("reports/getAllItemInventoryData", async (model, thunkAPi) => {
    try {
        let url = `/Report/ItemInventory`
        if (model?.from) {
            url = `${url}?from=${model?.from}`;
        }
        if (model?.to) {
            url = `${url}&to=${model?.to}`;
        }
        if (model?.DepotIds) {
            url = `${url}&depotIds=${model?.DepotIds}`;
        }
        if (model?.ClientIds) {
            url = `${url}&clientIds=${model?.ClientIds}`;
        }
        if (model?.ProjectIds) {
            url = `${url}&projectIds=${model?.ProjectIds}`;
        }
        {
            url = `${url}&isDateRange=${model?.isDateRange}`;
        }
        let result = await getAxios().get(`${url}`);
        let newResult = _.orderBy(result?.data, ['referenceNumber'], ['asc'])
        return newResult;
    } catch (error) {
        return thunkAPi.rejectWithValue(error);
    }
});
export const getAllReconcileData = createAsyncThunk("reports/getAllReconcileData", async (model, thunkAPi) => {
    try {
        let url = `/Reconciliation?fromDate=${model?.fromDate}&spaceType=${model?.spaceType || "internal"}&depotId=${model?.DepotIds || 0}&clientId=${model?.ClientIds || 0}&projectId=${model?.ProjectIds || 0}`
        let res = await getAxios().get(`${url}`);
        return res?.data || [];
    } catch (error) {
        return thunkAPi.rejectWithValue(error);
    }
});

export const PostReconciliation = createAsyncThunk(
    "goodsin/PostReconciliation",
    async (model, thunkAPi) => {
        try {
            let res = await getAxios().post("/Reconciliation", {
                ...model?.data
            });
            return res.data;
        } catch (error) {
            return thunkAPi.rejectWithValue(error);
        }
    }
);

export const GetExcelDataforReconciliation = createAsyncThunk(
    "goodsin/PostReconciliation",
    async (model, thunkAPi) => {
        try {
            let res = await getAxios().get(`/Reconciliation/GetAllReconciledRecords?depotId=${model?.DepotIds || 0}&projectId=${model?.ProjectIds || 0}&clientId=${model?.ClientIds || 0}&spaceType=${model?.spaceType || 0}&toDate=${model?.fromDate || 0}`);
            return res.data;
        } catch (error) {
            return thunkAPi.rejectWithValue(error);
        }
    }
);



